<template>
    <div ref="textData" class="text">
        <template v-if="needEllips">
           <slot :text="textData">
                <el-tooltip  effect="dark" :content="text" placement="top">
                    <span>{{textData}}</span>
                </el-tooltip>
            </slot>
        </template>
        <template v-else>{{textData}}</template>
    </div>
</template>

<script>
import CacheList from './util'
export default {
    name: 'TextEllips',
    data() {
        return {
            textData: '',
            width: 0,
            needEllips: false
        };
    },
    props: {
        text: {
            type: [String,Number],
            default: ''
        },
        rows: {
            type: Number,
            default: 1
        },
        keep: {
            type: Number,
            default: 0
        },
    },
    computed: {
        suffix() {
            return this.text.substring(this.text.length - this.keep)
        }
    },
    mounted() {
        this.runTask()
    },
    methods: {
        isEllipsis(textData, callback) {
            const w = this.$refs.textData?.clientWidth;
            if (!w || w<=0)  {
                setTimeout(()=> {
                     this.isEllipsis(textData, callback)
                }, 16)
                return
            };
            const { dom, range } = this.createRange(textData);
            if (range.getClientRects().length>this.rows) {
                this.needEllips = true
                this.needEllipsis(textData, callback)
            }else {
                this.needEllips = false
                this.textData = textData;
                callback()
            };
            dom.remove()
        },
        createRange(html) {
            const w = this.$refs.textData?.clientWidth;
            const div= document.createElement('div');
            div.classList.add('text-ellips-fixed');
            div.style.width = `${w}px`;
            div.textContent = html;
            document.body.appendChild(div)
            const range = document.createRange();
            range.setStart(div, 0);
            range.setEnd(div, div.childNodes.length);
            return {
                dom: div, range
            }
        },
        needEllipsis (html, callback) {
            let div = null;
            while(true) {
                if (div) {
                    div.remove();
                    div = null;
                }
                 const { dom, range } = this.createRange(html+'...'+this.suffix);
                 div = dom;
                if (range.getClientRects().length <= this.rows || !html) {
                    this.textData = html.slice(0, -1)+'...'+this.suffix
                    div.remove();
                    callback()
                    break;
                }else {
                    html = html.slice(0, -1)
                    
                }
            }
        },
        runTask(){
            CacheList.setCacheItem((callback)=> {
                this.$nextTick(()=> {
                    this.isEllipsis(this.text, callback)
                })
            })
        }
    },



    watch: {
        text: {
            handler(n) {
                this.runTask()
            },
        }
    },

    directives: {},

    filters: {}
};
</script>

<style lang="scss">
.text-ellips-fixed {
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    opacity: 0;
    word-break: break-all;
    z-index: -999;
}

</style>
<style lang="scss" scoped>
.text {
    word-break: break-all;
}
</style>
